import { SvgIcon, SvgIconProps } from '@mui/material';

export default function EmailIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 6.25C1.5 5.42157 2.17157 4.75 3 4.75H21C21.8284 4.75 22.5 5.42157 22.5 6.25V18.25C22.5 19.0784 21.8284 19.75 21 19.75H3C2.17157 19.75 1.5 19.0784 1.5 18.25V6.25Z"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.1609 5.30005L14.0169 11.564C12.8278 12.4788 11.172 12.4788 9.98287 11.564L1.83887 5.30005"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
